"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVideoMultiComponentParameters = void 0;
exports.UserVideoMultiComponentParameters = [
    {
        id: 'minCount',
        label: 'Minimum Count',
        description: 'Input Param - Minimum number of videos required',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'maxCount',
        label: 'Maximum Count',
        description: 'Input Param - Maximum number of videos allowed',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'videos',
        label: 'Videos',
        description: 'Output Param - Video files selected by the user',
        type: 'output',
        paramType: 'FILE_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserVideoMultiComponent.js.map